import { api } from "../api";

/**
 * customerFindAllListResponse - Function that finds on database all customers as select list   
 *`/customers/{managerId}/list 
 * method GET 
 * @async-function
 */
const customerFindAllListResponse = async (token: string, managerId: number) => {
    const response = await api.get(
        `/customers/${managerId}/list`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
         }
    );
    return response;
};
export default customerFindAllListResponse;